import styled from 'styles/styled';

export const GradientSection = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 32px 24px;
  background: linear-gradient(180deg, #15191E 0%, #000000 15%, #000000 33%, #15191E 100%);
  border-radius: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: 720px) {
    padding: 24px 16px;
    border-radius: 0 16px 16px 16px;
    gap: 16px;
  }
`;

export const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: 720px) {
    gap: 16px;
  }
`;

export const HeaderStack = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
`;
